import { useCallback, useMemo, useState } from 'react'

export function useDisclose(initState?: boolean) {
  const [isOpen, setIsOpen] = useState(initState ?? false)

  const onOpen = useCallback(() => {
    setIsOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const onToggle = useCallback((open?: boolean) => {
    setIsOpen((prev) => (open != null ? open : !prev))
  }, [])

  return useMemo(
    () => ({
      isOpen,
      onOpen,
      onClose,
      onToggle,
    }),
    [isOpen, onClose, onOpen, onToggle],
  )
}
